import { useState } from 'react';
import useBlacklist from '@/hooks/users/use-blacklist';
import useFuseSearch from '../search/use-fuse-search';

export default function useFilteredBlacklist() {
  const { blacklist, isLoading, error } = useBlacklist();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredBlacklist = useFuseSearch({
    data: blacklist,
    keyword: searchTerm,
    keys: ['BlackUserNickName'],
    mapResultItem: ({ item }) => item,
    initialReturnAll: true,
  });

  return {
    searchTerm,
    setSearchTerm,
    filteredBlacklist,
    blacklist,
    isLoading,
    error,
  };
}
